export default "__VITE_ASSET__CcrwGncW__"